export default "__VITE_ASSET__77884954__"